import React, { useState } from 'react';
import { Button, Card, Dropdown, notification, Space } from 'antd';
import { _T } from '../../../../../base-react/src/Localization';
import { DownOutlined, PartitionOutlined, TeamOutlined } from '@ant-design/icons';
import { apis, hooks, models } from "@vote4dance/judging-sdk";
var Api = apis.Api;
var Stream = hooks.streams.Stream;
var RoundItem = models.rounds.RoundItem;
var RoundTeamSource = models.teams.RoundTeamSource;
var ClassRoundSource = models.rounds.ClassRoundSource;
export const RoundAssignMatch = (props) => {
    const { round, classRounds, disabled } = props;
    const [teams, loadingTeams] = Stream(RoundTeamSource(round.round_id));
    const [loadingAssignMatches, setLoadingAssignMatches] = useState(false);
    const [loadingSendTeams, setLoadingSendTeams] = useState(false);
    const allEmptyMatches = teams === null || teams === void 0 ? void 0 : teams.every(a => a.heats_team_match_id == "0");
    const assignFromRound = (round_id) => {
        setLoadingAssignMatches(true);
        Api.call(`${ClassRoundSource(round.class_id).url}/${round.round_id}`, "assign-to-match", { source_id: round_id })
            .then(() => {
            setLoadingAssignMatches(false);
            notification.success({
                message: _T('round.sendTeams.assignSuccess')
            });
        })
            .catch((err) => {
            setLoadingAssignMatches(false);
            notification.error({
                message: _T(err.message)
            });
        });
    };
    const handleMenuClick = (e) => {
        assignFromRound(e.key);
    };
    const validRounds = classRounds && classRounds.filter((a, index) => (!RoundItem.isChildRound(a) || a.round_children > 0) &&
        a.round_id !== round.round_id &&
        ['closed', 'confirmed'].includes(a.round_status));
    const items = validRounds && validRounds.map((a) => ({
        label: a.round_label,
        key: a.round_id
    }));
    const menuProps = {
        items,
        onClick: handleMenuClick,
    };
    const confirmAndSendTeams = () => {
        setLoadingSendTeams(true);
        Api.call(`${ClassRoundSource(round.class_id).url}/${round.round_id}`, "send-to-match")
            .then(() => {
            setLoadingSendTeams(false);
            notification.success({
                message: _T('round.sendTeams.assignSuccess')
            });
        })
            .catch((err) => {
            setLoadingSendTeams(false);
            notification.error({
                message: _T(err.message)
            });
        });
    };
    return (React.createElement(Card, { title: React.createElement(React.Fragment, null,
            React.createElement(TeamOutlined, null),
            " ",
            _T('round.sendTeams.match.title')) },
        React.createElement(Space, { wrap: true },
            React.createElement(Dropdown, { menu: menuProps, disabled: disabled || (validRounds && validRounds.length == 0) },
                React.createElement(Button, { disabled: validRounds && validRounds.length == 0, loading: loadingAssignMatches || loadingTeams },
                    React.createElement(Space, null,
                        _T('round.sendTeams.match.source'),
                        React.createElement(DownOutlined, null)))),
            React.createElement(Button, { key: "confirm", disabled: allEmptyMatches || disabled, type: "primary", icon: React.createElement(PartitionOutlined, null), onClick: () => confirmAndSendTeams(), loading: loadingSendTeams }, _T('round.sendTeams.match.action')))));
};
